import { clsx } from 'clsx';

import type { ReactNode } from 'react';

import styles from './Notification.module.css';

import { Icon } from 'components/Icon';

export type NotificationVariant = 'default' | 'bar';
export type NotificationLevel = 'neutral' | 'information' | 'success' | 'warning' | 'danger';

export interface NotificationProps {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  variant?: NotificationVariant;
  level: NotificationLevel;
  onClose?: () => void;
}

export const Notification = ({ title, subtitle, action, variant = 'default', level, onClose }: NotificationProps) => {
  const isBar = variant === 'bar';

  function setIconName(toastType: NotificationLevel) {
    if (toastType === 'neutral') return 'CalendarEdit';
    if (toastType === 'information') return 'SquareInfo';
    if (toastType === 'success') return 'CheckCircle';
    return 'ExclamationTriangleMini';
  }

  return (
    <div className={clsx(styles['notification'], styles[`notification--${variant}`], styles[`notification--${level}`])}>
      <div className={styles['notification-content']}>
        <Icon name={setIconName(level)} />
        <div className={styles['notification-content--text']}>
          {title && <p className={styles['notification-title']}>{title}</p>}
          {subtitle && <p className={styles['notification-subtitle']}>{subtitle}</p>}
          {action && <div className={styles['notification-action']}>{action}</div>}
        </div>
      </div>
      {onClose && (
        <button
          type="button"
          aria-label="close"
          className={clsx(styles['notification-close-button'], styles[`notification-close-button--${level}`], {
            [styles[`notification-close-button--bar--${level}`]]: isBar,
          })}
        >
          <Icon name="Cross" size={24} />
        </button>
      )}
    </div>
  );
};
